export const getSituacionLaboral = (values) => ({
    tiene_contrato_laboral: values.tieneContratoLaboral.id,
    tipo_contrato:
        values.tieneContratoLaboral.id == 30 ? values?.tipoContrato?.id : null,
    ingresos_actuales: values.ingresosActuales.id,
});
